import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import {tokenAxios, baseUrlForEnvironment} from '../components/utils/Axios';
import { removeUserSession, setUserSession, validateToken } from '../components/utils/Common';
import { useNavigate, Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import logo from '../resources/images/logo_PME.png';
import ConnexionImageBack from '../resources/images/connexion_image_back.svg';
import ConnexionImageMiddle from '../resources/images/connexion_image_middle.svg';
import ConnexionImageFront from '../resources/images/connexion_image_front.svg';
import Header from '../components/Header';

function Connexion() {
    const navigate = useNavigate();
    const username = useFormInput('');
    const password = useFormInput('');
    const [error, setError] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [isRememberSelected, setIsRememberSelected] = useState<boolean>(false);
    const [isHelpOpen, setIsHelpOpen] = useState<boolean>(false);
    const helpRef = useRef<HTMLDivElement>(null);

    const hasValidSession = validateToken();

    useEffect(() => {
        if (!hasValidSession) {
            removeUserSession();
        }
    }, [hasValidSession]);

    useEffect(() => {
        if (!isHelpOpen) return;

        const handleClickOutside = (e: MouseEvent) => {
            if (helpRef.current && !helpRef.current.contains(e.target as Node)) {
                setIsHelpOpen(false);
            }
        };
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setIsHelpOpen(false);
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isHelpOpen]);

    const handleLogin = (e:any) => {
        e.preventDefault()
        setError('');
        setLoading(true);
        tokenAxios.post('', 
            { username: username.value, password: password.value, remember: isRememberSelected })
        .then(response => {
            setLoading(false);
            setUserSession(response.data.data.token, response.data.data);
            navigate('/');
        }).catch(error => {
            setLoading(false);
            if (error.response.status === 401) setError(error.response.data.message);
            else setError("La connexion s'est mal passée. Veuillez réessayer.");
        });
    }

    if (hasValidSession) {
        return <Navigate to="/" replace />;
    }

    return (
        <React.Fragment>
            <header>
                <title>PME Internotaire extranet - Connexion</title>
                <link rel="icon" type="image/png" href="/images/favicon.png" />
            </header>

            <Header pageName='connexion'/>
            <main className="login-page" >
                <div className='login-page__background connexion'>
                    <div className='login-page__background__column1'></div>
                    <div className='login-page__background__column2'>
                        <div className='login-page__background__column2__container'>
                            <img src={ConnexionImageBack} alt='Network' />
                            <img src={ConnexionImageMiddle} alt='Network' />
                            <img src={ConnexionImageFront} alt='Network' />
                        </div>
                    </div>
                </div>
                <form className='login-page__columns' onSubmit={handleLogin}>
                    <div className='login-page__columns__content'>
                        <img src={logo} alt='Logo' />
                        <h1>Extranet</h1>
                        <h2>Connexion</h2>
                        <input placeholder='Identifiant ou adresse de messagerie' type="text" {...username} autoComplete="new-password" />
                        <input placeholder='Mot de passe' type="password" {...password} autoComplete="new-password" />
                        {error && <p className='error-message'>{error}</p>}
                        <div className='remember-row' ref={helpRef}>
                            <label className='remember-checkbox'>
                                <input
                                    type="checkbox"
                                    name='remember'
                                    checked={isRememberSelected}
                                    onChange={() => setIsRememberSelected(prevValue => !prevValue)}
                                    className=""
                                />
                                Se souvenir de moi
                            </label>
                            <button
                                type="button"
                                className='remember-help'
                                aria-label='Aide sur « Se souvenir de moi »'
                                aria-expanded={isHelpOpen}
                                aria-controls='remember-help-popover'
                                onPointerEnter={(e) => { if (e.pointerType !== 'touch') setIsHelpOpen(true); }}
                                onPointerLeave={(e) => { if (e.pointerType !== 'touch') setIsHelpOpen(false); }}
                                onFocus={() => setIsHelpOpen(true)}
                                onBlur={() => setIsHelpOpen(false)}
                                onClick={() => setIsHelpOpen(true)}
                            >
                                <FontAwesomeIcon icon={faCircleQuestion} />
                            </button>
                            {isHelpOpen && (
                                <div className='remember-help__popover' id='remember-help-popover' role='tooltip'>
                                    Si cette case est cochée, vous resterez connecté pendant 7 jours, même après avoir fermé votre navigateur. Sinon, votre session expirera après 10 minutes.
                                </div>
                            )}
                        </div>
                        <input type="submit" value={loading ? 'Chargement...' : 'Se connecter'} disabled={loading} /><br />
                        <a href={`${baseUrlForEnvironment}/wp-login.php?action=lostpassword`} className='password-link'>Mot de passe oublié</a>
                    </div>
                    <div className='login-page__columns__image'>
                    </div>
                </form>
            </main>
        </React.Fragment>
    );
}



const useFormInput = (initialValue: any) => {
    const [value, setValue] = useState(initialValue);
   
    const handleChange = (e: any) => {
      setValue(e.target.value);
    }
    return {
      value,
      onChange: handleChange
    }
}
   

export default Connexion;
